export default __webpack_public_path__ + "static/media/diploma-desactivando-aflicciones.1f612909.jpeg";